import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Switch } from 'antd';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';
import classNames from 'classnames';
import style from './ComboItemsSwitch.module.scss';

const ComboItemsSwitch: React.FC = () => {
	const { isShowOnlyComboItems, toggleShowComboItems } = useContext<IDishesContext>(DishesContext);

	const switchElementClass = classNames({ [style.switchActive]: isShowOnlyComboItems });

	return (
		<div className={style.container} data-test="ComboItemsSwitch">
			<Switch className={switchElementClass} checked={isShowOnlyComboItems} onChange={toggleShowComboItems} />
			<Text
				className={style.switchLabel}
				translationNameSpace="listing"
				translationKey="showOnlyComboItemsLabel"
				theme="neutralLight"
				weight="thin"
			/>
		</div>
	);
};

export default ComboItemsSwitch;
